module.exports = __webpack_public_path__ + "img/cardapio.c4665da7.svg";